module.exports = __webpack_public_path__ + "img/universita-della-valle-daosta.6320f28c.jpg";